module.exports = __webpack_public_path__ + "static/shape-group-3-f4cb74f7bcf9f7603cf8924d95fa754e.svg";